import React from 'react'
import { useSelector } from 'react-redux'
import * as E from './footerElements'

interface IStateProps {
  individualEstimate: { isGov: boolean }
}

interface IInputProps {
  classes: string
  text: string
  nonGovLink?: string
  govLink?: string
  ariaLabel?: string
}

const LinkGov = ({
  classes,
  text,
  nonGovLink,
  govLink,
  ariaLabel,
}: IInputProps) => {
  let isGov = useSelector(
    (state: IStateProps) => state.individualEstimate.isGov
  )
  return (
    <E.FooterLinks
      className={classes ? classes : ''}
      href={isGov ? govLink || nonGovLink : nonGovLink}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={ariaLabel}
    >
      {text}
    </E.FooterLinks>
  )
}

export default LinkGov
